import { createContext } from "react";
export var ConfigContext = createContext({
    classPrefix: "tea",
    locale: "zh",
});
//# sourceMappingURL=ConfigContext.js.map